import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ListingsPage from '@/pages/listings/page';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import RequestPage from '@/pages/request/page';
import AdminPage from '@/pages/admin/page';
import SellPage from '@/pages/sell/page';
import BuyPage from '@/pages/buy/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/listings', element: <ListingsPage /> },
  { path: '/buy', element: <BuyPage /> },
  { path: '/sell', element: <SellPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/request', element: <RequestPage /> },
  { path: '/admin', element: <AdminPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
